'use client';

import type { FavouriteProduct } from '@dealerportal/common';
import { useEffect, useState } from 'react';

interface Props {
  id: string;
  name: string;
  className: string;
  placeholderText: string;
}

export const FormNotes = (props: Props) => {
  const [notes, setNotes] = useState('');
  useEffect(() => {
    const favorites = JSON.parse(localStorage.getItem('favourites') ?? '[]');
    const favoritesArray = favorites.map((favorite: FavouriteProduct) => {
      return {
        upid: favorite?.UPID,
        productType: favorite?.productType ?? '',
        productName: favorite?.productName ?? '',
        colorName: favorite?.colorName ?? '',
        brandName: favorite?.brandName ?? '',
      };
    });
    const stringifiedFavs = JSON.stringify(favoritesArray);
    setNotes(stringifiedFavs);
  }, []);
  return <input {...props} value={notes} />;
};

export default FormNotes;
